export default __webpack_public_path__ + "static/media/O-105.536c8488.png";